import React, { Component } from "react";
import { Router, Switch, Redirect } from "react-router-dom";
import history from "Helpers/History";
import { withTranslation } from 'react-i18next';
import { read, store } from "Helpers/LocalStorage";
import PublicRoute from "hoc/Routes/PublicRoute/PublicRoute";
import Auth from "Screens/Auth/Auth";
import PrivateRoute from "hoc/Routes/PrivateRoute/PrivateRoute";
import MaintenanceIndex from "Screens/Maintenance";
import BankTransactionIndex from "Screens/BankTransaction";
import { connect } from "react-redux";
import Dashboard from "Screens/Dashboard/Dashboard";
import SuperIndex from "Screens/Super/Super";
import "Styles/index.scss";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import Design from "Screens/Design/Design";
import SuperRoute from "hoc/Routes/SuperRoute/SuperRoute";
import { SocketConnection } from "Services/http/SocketConnection";
import PrivacyPolicy from "Screens/Auth/PrivacyPolicy/PrivacyPolicy";
import { isSuperAdmin } from "Helpers/analyzeToken";
import { getUserData } from "Stores/actions";
import DashboardExiter from "Components/DashboardExiter/DashboardExiter";

class App extends Component {
  componentDidMount() {
    if(!this.props.isLoggedIn) {
      store('internalLanguage', this.props.locale.locale);
      this.props.i18n.changeLanguage(this.props.locale.locale);
    }
    if(isSuperAdmin()) {
      this.props.GetUserData();
    }
    if(this.props.isLoggedIn) {
      this.props.SocketConnection();
    }
  }
  componentDidUpdate(prevProps) {
    if(prevProps.locale.locale !== this.props.locale.locale) {
      store('internalLanguage', this.props.locale.locale);
      this.props.i18n.changeLanguage(this.props.locale.locale);
    }
    if(prevProps.isLoggedIn !== this.props.isLoggedIn && this.props.isLoggedIn) {
      this.props.SocketConnection();
    }
  }
  render() {
    const { isLoggedIn, rtl, transfer } = this.props;
    return (
      <Router history={history}>
        <div className="App" dir={rtl ? 'RTL' : 'LTR'}>
          <DashboardExiter visible={transfer} />
          <Switch>
            <PublicRoute
              exact
              path="/privacy"
              component={PrivacyPolicy}
            />
            <PublicRoute
              path="/auth"
              component={Auth}
              restricted
              isLoggedIn={isLoggedIn}
            />
            <PrivateRoute
              path="/dashboard"
              component={Dashboard}
              isLoggedIn={isLoggedIn}
            />
            <PrivateRoute
              path="/design"
              component={Design}
              isLoggedIn={isLoggedIn}
            />
            <PrivateRoute
              path="/maintenance"
              component={MaintenanceIndex}
              isLoggedIn={isLoggedIn}
            />
            <SuperRoute 
              path="/admin"
              component={SuperIndex}
              isLoggedIn={isLoggedIn}
            />
            <PublicRoute
              path="/payment"
              component={BankTransactionIndex}
              restricted
            />
            {isLoggedIn !== undefined ? (
              <Redirect exact from="/" to="/dashboard" />
            ) : (
              <Redirect exact from="/" to="/auth" />
            )}
          </Switch>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn,
  rtl: state.settings.rtlLayout,
  locale: state.settings.locale,
  transfer: state.auth.transfer,
});

const mapDispatchToProps = (dispatch) => ({
  SocketConnection: () => dispatch(SocketConnection()),
  GetUserData: () => dispatch(getUserData({
    KeyGroup: read("groupKey"),
    KeyUser: read("userKey"),
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));